import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '../../../../pipes/safe-html.pipe';

type SignoVitalItem = {
  nombre: string;
  valor: string | number;
  unidad: string;
  icono: string | string[];
  viewBox: string;
};

@Component({
  selector: 'app-resumen-nota',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './resumen-nota.component.html',
  styleUrls: ['./resumen-nota.component.scss'],
})
export class ResumenNotaComponent {
  @Input() nota: any = null;
  @Input() mostrarBotonResumenCompleto: boolean = true;
  @Input() usarScrollInterno: boolean = true;
  @Input() esVistaModal: boolean = false;
  @Output() verResumenCompleto = new EventEmitter<void>();

  private readonly ICONOS: Record<string, string | string[]> = {
    TA: 'M18.5869 5.25957C16.9524 3.3719 15.1127 1.67209 13.102 0.191572C12.924 0.0668851 12.712 0 12.4947 0C12.2773 0 12.0653 0.0668851 11.8873 0.191572C9.88029 1.67271 8.04426 3.37249 6.41307 5.25957C2.77549 9.43703 0.855469 13.8408 0.855469 17.9957C0.855469 21.084 2.0823 24.0459 4.26606 26.2296C6.44983 28.4134 9.41165 29.6402 12.5 29.6402C15.5883 29.6402 18.5501 28.4134 20.7339 26.2296C22.9176 24.0459 24.1444 21.084 24.1444 17.9957C24.1444 13.8408 22.2244 9.43703 18.5869 5.25957ZM19.8902 19.2316C19.6157 20.7649 18.8781 22.1772 17.7766 23.2785C16.675 24.3798 15.2625 25.1171 13.7292 25.3913C13.6728 25.4003 13.6157 25.4051 13.5585 25.4059C13.293 25.4058 13.0372 25.3059 12.8418 25.1261C12.6465 24.9462 12.5259 24.6995 12.5039 24.4349C12.4819 24.1703 12.5602 23.9071 12.7232 23.6974C12.8862 23.4878 13.122 23.3471 13.3839 23.3032C15.5765 22.9341 17.437 21.0736 17.8088 18.877C17.8558 18.6001 18.0109 18.3532 18.24 18.1907C18.469 18.0282 18.7532 17.9633 19.0301 18.0103C19.307 18.0573 19.5539 18.2124 19.7164 18.4415C19.879 18.6705 19.9439 18.9547 19.8969 19.2316H19.8902Z',
    FC: 'M23.689 0C26.3819 0 28.6376 0.996393 30.4558 2.98918C32.2741 4.98196 33.1827 7.35176 33.1817 10.0986C33.1817 10.5833 33.1547 11.0616 33.1009 11.5334C33.047 12.0052 32.9528 12.4695 32.8181 12.9262H22.7195L19.9727 8.80596C19.8381 8.59052 19.6496 8.41548 19.4072 8.28083C19.1648 8.14618 18.909 8.07886 18.6397 8.07886C18.2896 8.07886 17.9735 8.18658 17.6912 8.40202C17.409 8.61745 17.2135 8.88675 17.1047 9.2099L14.9234 15.7538L13.5096 13.6533C13.375 13.4378 13.1865 13.2628 12.9441 13.1281C12.7017 12.9935 12.4459 12.9262 12.1766 12.9262H1.22976C1.09511 12.4684 1.00086 12.0041 0.946999 11.5334C0.89314 11.0627 0.866211 10.5978 0.866211 10.139C0.866211 7.36523 1.76835 4.98196 3.57263 2.98918C5.37691 0.996393 7.62552 0 10.3185 0C11.6111 0 12.8299 0.25583 13.975 0.767492C15.12 1.27915 16.1363 1.99279 17.0239 2.90839C17.8857 1.99279 18.8891 1.27915 20.0341 0.767492C21.1792 0.25583 22.3975 0 23.689 0ZM17.0239 29.0839C16.5392 29.0839 16.0749 28.9966 15.6311 28.8221C15.1873 28.6476 14.7899 28.3848 14.4387 28.0336L3.61302 17.1676C3.45145 17.006 3.30333 16.8444 3.16869 16.6828C3.03404 16.5213 2.89939 16.3462 2.76474 16.1577H11.2879L14.0348 20.2779C14.1694 20.4934 14.3579 20.6684 14.6003 20.8031C14.8426 20.9377 15.0985 21.005 15.3678 21.005C15.7179 21.005 16.041 20.8973 16.3372 20.6819C16.6335 20.4664 16.8354 20.1972 16.9431 19.874L19.1244 13.3301L20.4978 15.4306C20.6594 15.6461 20.8614 15.8211 21.1038 15.9558C21.3461 16.0904 21.602 16.1577 21.8713 16.1577H31.2427L30.8388 16.6425L30.4348 17.1272L19.5688 28.0336C19.2187 28.3837 18.8282 28.6466 18.3973 28.8221C17.9665 28.9977 17.5087 29.085 17.0239 29.0839Z',
    FR: 'M14.4794 7.1118L14.7988 11.2724L15.2742 10.9567C15.5346 10.783 15.748 10.5478 15.8956 10.2718C16.0432 9.99578 16.1204 9.68763 16.1204 9.37465V1.90155C16.1204 1.39723 16.3207 0.913561 16.6774 0.556951C17.034 0.200341 17.5176 0 18.0219 0C18.5263 0 19.0099 0.200341 19.3665 0.556951C19.7232 0.913561 19.9235 1.39723 19.9235 1.90155V9.37465C19.9235 9.68763 20.0007 9.99578 20.1483 10.2718C20.2959 10.5478 20.5093 10.783 20.7697 10.9567L21.2451 11.2724L21.5645 7.1118C21.7946 4.11876 25.2383 2.55949 27.6381 4.36026L28.7505 5.19314C31.5348 7.28194 33.3901 10.3783 33.9189 13.8186L35.9726 27.1656C36.6533 31.5905 32.2037 35.0399 28.0869 33.2771L26.0807 32.4157C24.2564 31.6336 22.7226 30.3 21.6944 28.6021C20.6662 26.9042 20.1953 24.927 20.3475 22.9479L20.9104 15.6212L18.6609 14.119C18.4365 13.9695 18.223 13.8043 18.0219 13.6246C17.8209 13.8043 17.6074 13.9695 17.383 14.119L15.1335 15.6212L15.6964 22.9479C15.849 24.9273 15.3783 26.9049 14.3501 28.6032C13.3219 30.3015 11.7879 31.6354 9.96318 32.4176L7.95514 33.2771C3.84018 35.0399 -0.611346 31.5905 0.0694088 27.1656L2.12308 13.8186C2.65235 10.378 4.50839 7.28159 7.2934 5.19314L8.4039 4.36026C10.8056 2.55949 14.2493 4.11876 14.4794 7.1118Z',
    TEMP: 'M8.20053 0C8.81118 0 9.39705 0.242532 9.83026 0.675739C10.2635 1.10895 10.506 1.69482 10.506 2.30547V18.5984C11.7677 19.2865 12.7921 20.3425 13.4382 21.6239C14.0843 22.9053 14.3212 24.3522 14.117 25.7699C13.9128 27.1876 13.2775 28.5078 12.2966 29.5523C11.3157 30.5968 10.0365 31.3146 8.6328 31.6065C7.22915 31.8984 5.77062 31.7504 4.45235 31.1817C3.13407 30.613 2.01961 29.6502 1.25626 28.4173C0.492902 27.1844 0.115234 25.7397 0.174102 24.2774C0.23297 22.8151 0.725414 21.4056 1.58133 20.2365V2.30547C1.58133 1.69482 1.82387 1.10895 2.25707 0.675739C2.69028 0.242532 3.27615 0 3.8868 0L8.20053 0ZM8.20053 1.53031H3.8868C3.68148 1.53031 3.48456 1.61177 3.33925 1.75708C3.19394 1.90239 3.11248 2.09931 3.11248 2.30463V20.9273C3.11208 21.1094 3.16693 21.2876 3.26987 21.4397C3.37281 21.5917 3.51929 21.7109 3.69076 21.7821C4.79076 22.2364 5.70148 23.0642 6.27191 24.1285C6.84235 25.1927 7.03767 26.424 6.82407 27.6136C6.61046 28.8032 6.00086 29.8796 5.09807 30.6676C4.19527 31.4556 3.05374 31.9064 1.86626 31.9455C2.79869 33.2207 4.08833 34.183 5.57264 34.7075C7.05694 35.2321 8.66616 35.2941 10.1872 34.8849C11.7082 34.4757 13.0694 33.6143 14.0862 32.4141C15.1029 31.2138 15.7264 29.7331 15.8738 28.1641C16.0211 26.5951 15.6854 25.0194 14.9107 23.6457C14.1361 22.272 12.959 21.1652 11.5403 20.4767C11.3688 20.4055 11.2224 20.2863 11.1194 20.1342C11.0165 19.9822 10.9616 19.804 10.9613 19.6219V2.30547C10.9613 2.10015 10.8798 1.90323 10.7345 1.75792C10.5892 1.61261 10.3923 1.53115 10.187 1.53115L8.20053 1.53031ZM6.04367 11.4883C6.04367 11.0776 6.20677 10.6838 6.49728 10.3933C6.78779 10.1028 7.1816 9.93965 7.59233 9.93965C8.00305 9.93965 8.39686 10.1028 8.68737 10.3933C8.97788 10.6838 9.14098 11.0776 9.14098 11.4883V22.7695C9.59098 22.9078 10.0014 23.1517 10.3378 23.4819C10.6742 23.812 10.9275 24.2192 11.077 24.6679C11.2265 25.1166 11.268 25.5944 11.1981 26.062C11.1283 26.5296 10.9491 26.9737 10.6753 27.3581C10.4014 27.7425 10.0408 28.0565 9.62289 28.2738C9.20499 28.4912 8.74163 28.6057 8.27098 28.608C7.80033 28.6104 7.33581 28.5006 6.91581 28.2874C6.49581 28.0743 6.13224 27.7638 5.85481 27.3823C5.49367 26.8817 5.29772 26.2773 5.29367 25.6558C5.29254 25.3091 5.35727 24.9653 5.4844 24.6426C5.61152 24.3199 5.7987 24.0246 6.03567 23.7737C6.27263 23.5228 6.55471 23.3211 6.86624 23.1798C7.17777 23.0385 7.51278 22.9603 7.85281 22.9498V11.4883H6.04367Z',
    SPO2: 'M6.28781 29.3839C7.95452 29.3839 9.31061 30.7385 9.31061 32.4067C9.31061 34.0749 7.95607 35.4295 6.28781 35.4295C4.6211 35.4295 3.26501 34.0749 3.26501 32.4067C3.26501 30.7385 4.61955 29.3839 6.28781 29.3839ZM35.0984 29.3839C36.7667 29.3839 38.1228 30.7385 38.1228 32.4067C38.1228 34.0749 36.7682 35.4295 35.0984 35.4295C33.4317 35.4295 32.0756 34.0749 32.0756 32.4067C32.0756 30.7385 33.4301 29.3839 35.0984 29.3839ZM33.1667 0C34.3088 0 35.2923 0.732076 35.6969 1.76156L41.0298 17.3098C41.4499 18.3858 41.122 19.6086 40.2282 20.3561C39.3343 21.1036 38.066 21.2106 37.056 20.6213L32.7776 18.0861H8.68301L4.3891 20.6213C3.37908 21.2106 2.11076 21.1036 1.2169 20.3561C0.323044 19.6086 -0.00634384 18.3843 0.413758 17.3098L5.77804 1.76156C6.18268 0.732076 7.16616 0 8.30828 0H33.1667ZM36.8714 15.5863C35.3768 15.5863 34.1541 14.3635 34.1541 12.8689C34.1541 11.3743 35.3768 10.1516 36.8714 10.1516C38.3661 10.1516 39.5888 11.3743 39.5888 12.8689C39.5888 14.3635 38.3661 15.5863 36.8714 15.5863ZM33.1667 2.89244H8.30672L3.5112 16.7969L8.68301 13.7034H32.7776L37.9635 16.7969L33.1667 2.89244ZM26.3354 5.53076C28.1437 5.53076 29.6228 7.00975 29.6228 8.81807C29.6228 10.6264 28.1437 12.1054 26.3354 12.1054H15.1388C13.3305 12.1054 11.8515 10.6264 11.8515 8.81807C11.8515 7.00975 13.3305 5.53076 15.1388 5.53076H26.3354ZM26.3354 8.42319H15.1388C15.4752 8.42319 15.7582 8.68473 15.7582 9.0211C15.7582 9.33557 15.5295 9.59245 15.2276 9.61681L15.1388 9.61901H26.3354C26.6718 9.61901 26.9548 9.33557 26.9548 8.9992C26.9548 8.68629 26.7264 8.42941 26.4245 8.40349L26.3354 8.42319Z',
    PESO: 'M40.2099 38.2219C40.0921 40.3416 38.339 42 36.2161 42L11.784 42C9.66102 42 7.90787 40.3415 7.79011 38.2219L6.23456 10.2219C6.10718 7.92907 7.93206 6 10.2284 6L37.7716 6C40.068 6 41.8928 7.92908 41.7655 10.2219L40.2099 38.2219ZM34.2442 17.7786C35.064 17.2385 35.2702 16.1677 34.5974 15.471C33.4729 14.3066 32.139 13.3305 30.6524 12.5895C28.6303 11.5817 26.3828 11.0377 24.0939 11.0019C21.805 10.9661 19.5395 11.4396 17.4828 12.3837C15.9707 13.0778 14.603 14.0117 13.4379 15.1403C12.7407 15.8156 12.9089 16.8922 13.7092 17.4577L18.0211 20.5042C18.8214 21.0696 19.9487 20.8868 20.7779 20.3594C20.9902 20.2244 21.2129 20.1032 21.4445 19.9969C22.1757 19.6612 22.9766 19.4829 23.7891 19.4741L27.1821 15.5729C27.5445 15.1562 28.1761 15.1122 28.5929 15.4746C29.0096 15.837 29.0536 16.4687 28.6912 16.8854L26.0608 19.9098C26.1835 19.9605 26.3044 20.0155 26.4232 20.0747C26.6509 20.1882 26.8692 20.3163 27.0766 20.4579C27.8867 21.0108 29.0068 21.2288 29.8267 20.6887L34.2442 17.7786Z',
    TALLA: [
      'M0.00156614 1.8598L0.376383 8.78403C0.435564 10.0466 0.928743 10.7765 1.81647 11.4275L6.09725 14.5641C6.62989 14.9389 6.9258 15.2151 6.9258 16.1423V41.8861C6.9258 42.9515 7.7938 43.7998 8.85906 43.7998C9.92432 43.7998 10.7726 42.9515 10.7726 41.8861V28.0378C10.7726 27.6826 11.0882 27.3669 11.4433 27.3669C11.7984 27.3669 12.0943 27.6826 12.0943 28.0378V41.8861C12.0943 42.9515 12.9623 43.7998 14.0276 43.7998C15.0928 43.7998 15.9411 42.9515 15.9411 41.8861V19.0224C15.9411 18.6674 16.237 18.3911 16.5921 18.3911C16.9471 18.3911 17.2234 18.6674 17.2234 19.0224V26.6173C17.2234 27.6038 18.0124 28.3731 18.9791 28.3731C19.9457 28.3731 20.7347 27.6038 20.7347 26.6173V18.1348C20.7347 13.775 17.539 10.8751 12.8834 10.8751H8.78014C7.59652 10.8751 6.86662 10.6384 5.91972 9.96765L3.8681 8.50786L3.49327 1.68225C3.45382 0.715625 2.62527 -0.0734619 1.65865 0.00544683C0.67229 0.0843554 -0.0378881 0.893168 0.00156614 1.8598ZM11.4433 8.66567C13.8303 8.66567 15.7438 6.75214 15.7438 4.36515C15.7438 1.97816 13.8303 0.0646283 11.4433 0.0646283C9.05634 0.0646283 7.1428 1.97816 7.1428 4.36515C7.1428 6.75214 9.05634 8.66567 11.4433 8.66567Z',
      'M27.8881 43.3496L31.2063 38.8808C31.9067 37.947 31.4898 36.8465 30.3393 36.8465L28.2883 36.8465V32.5445C28.2883 31.8108 27.7213 31.2272 26.9877 31.2272C26.2707 31.2272 25.6871 31.8108 25.6871 32.5445L25.6871 36.8465H23.6694C22.4689 36.8465 22.1187 37.9804 22.7857 38.8808L26.1206 43.3496C26.5875 43.9499 27.4379 43.9499 27.8881 43.3496ZM26.9877 12.5684C27.7213 12.5684 28.2883 12.0014 28.2883 11.2677V6.96577L30.3393 6.96577C31.4898 6.96577 31.9067 5.84852 31.2063 4.93146L27.8881 0.462725C27.4379 -0.154242 26.5875 -0.154242 26.1206 0.462725L22.7857 4.93146C22.1187 5.81522 22.4689 6.96577 23.6694 6.96577H25.6871V11.2677C25.6871 12.0014 26.2707 12.5684 26.9877 12.5684Z'
    ],
    IMC: 'M8.43134 2.70143C7.54504 2.70143 6.69503 3.12835 6.06832 3.88827C5.44161 4.6482 5.08953 5.67888 5.08953 6.75357V20.227L4.71859 20.6295C3.87773 21.5413 3.28502 22.7411 3.01889 24.0704C2.75275 25.3996 2.82575 26.7954 3.22821 28.0732C3.63068 29.351 4.34363 30.4505 5.27274 31.2262C6.20184 32.0019 7.3033 32.4173 8.43134 32.4173C9.55938 32.4173 10.6608 32.0019 11.5899 31.2262C12.519 30.4505 13.232 29.351 13.6345 28.0732C14.0369 26.7954 14.1099 25.3996 13.8438 24.0704C13.5777 22.7411 12.9849 21.5413 12.1441 20.6295L11.7731 20.227V6.75357C11.7731 5.67888 11.4211 4.6482 10.7943 3.88827C10.1676 3.12835 9.31764 2.70143 8.43134 2.70143ZM2.86166 6.75357C2.86166 4.96241 3.44847 3.24462 4.49298 1.97808C5.5375 0.711535 6.95417 0 8.43134 0C9.90851 0 11.3252 0.711535 12.3697 1.97808C13.4142 3.24462 14.001 4.96241 14.001 6.75357V19.0464C15.0756 20.3763 15.8025 22.0612 16.0905 23.89C16.3785 25.7188 16.2148 27.6099 15.62 29.3263C15.0252 31.0428 14.0257 32.5081 12.7469 33.5385C11.468 34.5689 9.96677 35.1185 8.43134 35.1185C6.8959 35.1185 5.39465 34.5689 4.11581 33.5385C2.83697 32.5081 1.83748 31.0428 1.24266 29.3263C0.64785 27.6099 0.484188 25.7188 0.772202 23.89C1.06022 22.0612 1.78708 20.3763 2.86166 19.0464V6.75357ZM7.3174 12.1564C7.3174 11.7982 7.43476 11.4546 7.64367 11.2013C7.85257 10.948 8.1359 10.8057 8.43134 10.8057C8.72677 10.8057 9.01011 10.948 9.21901 11.2013C9.42791 11.4546 9.54527 11.7982 9.54527 12.1564V21.8411C10.2888 22.1597 10.9155 22.7868 11.3146 23.6116C11.7137 24.4363 11.8595 25.4056 11.7261 26.3481C11.5928 27.2906 11.189 28.1456 10.5861 28.7619C9.98317 29.3783 9.21995 29.7164 8.43134 29.7164C7.64272 29.7164 6.8795 29.3783 6.27657 28.7619C5.67365 28.1456 5.26984 27.2906 5.13653 26.3481C5.00322 25.4056 5.14899 24.4363 5.54807 23.6116C5.94716 22.7868 6.57386 22.1597 7.3174 21.8411V12.1564Z'
  };

  private readonly VIEWBOXES: Record<string, string> = {
    TA: '0 0 25 30',
    FC: '0 0 34 30',
    FR: '0 0 36 44',
    TEMP: '0 0 17 36',
    SPO2: '0 0 42 44',
    PESO: '0 0 48 42',
    TALLA: '0 0 32 44',
    IMC: '0 0 17 36'
  };

  get tipoNota(): string {
    return this.nota?.type || 'desconocido';
  }

  get tipoNotaLabel(): string {
    const tipoMap: Record<string, string> = {
      consulta: 'Consulta Medica',
      'consulta-medica': 'Consulta Medica',
      urgencias: 'Urgencias',
      'nota-urgencias': 'Urgencias',
      ingreso: 'Ingreso',
      'nota-ingreso': 'Ingreso',
      evolucion: 'Evolucion',
      'nota-evolucion': 'Evolucion',
      egreso: 'Egreso',
      'nota-egreso': 'Egreso',
    };
    return tipoMap[this.tipoNota] || 'Nota Medica';
  }

  get numeroNotaPorTipo(): number {
    const raw =
      this.nota?.sequence_number ??
      this.nota?.note_number ??
      this.nota?.numero_nota ??
      this.nota?.numero ??
      this.nota?.sequenceNumber;

    const numero = Number(raw);
    return Number.isFinite(numero) && numero > 0 ? Math.floor(numero) : 1;
  }

  get tituloNotaHeader(): string {
    return `${this.tipoNotaLabel} #${this.numeroNotaPorTipo}`;
  }

  get nombreDoctorHeader(): string {
    const doctorObj = this.nota?.doctor;
    const nombre =
      `${doctorObj?.name || ''} ${doctorObj?.last_name || doctorObj?.lastname || ''}`.trim() ||
      this.nota?.doctor_name ||
      'Medico';
    return `Dr. ${nombre}`;
  }

  get estadoNotaTexto(): string {
    const status = (this.nota?.status || '').toLowerCase();
    if (status === 'completada') return 'Completada';
    if (status === 'abierta') return 'Abierta';
    if (status === 'cancelada') return 'Cancelada';
    return 'N/A';
  }

  get estadoNotaBadgeClass(): string {
    const status = (this.nota?.status || '').toLowerCase();
    if (status === 'completada') return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    if (status === 'abierta') return 'bg-amber-100 text-amber-700 border-amber-200';
    if (status === 'cancelada') return 'bg-rose-100 text-rose-700 border-rose-200';
    return 'bg-slate-100 text-slate-700 border-slate-200';
  }

  get tieneSecciones(): boolean {
    return this.nota !== null && this.nota !== undefined;
  }

  get tieneAntecedentes(): boolean {
    return ['consulta', 'urgencias', 'ingreso', 'evolucion', 'egreso'].includes(this.tipoNota);
  }

  get tieneAntecedentesConDatos(): boolean {
    if (!this.tieneAntecedentes) return false;

    const tieneGineco = !this.esPacienteMasculino && this.tieneValorConContenido(this.antecedentesGinecoObstetricos);
    return (
      this.tieneValorConContenido(this.antecedentesHeredofamiliares) ||
      this.tieneValorConContenido(this.antecedentesPatologicos) ||
      this.tieneValorConContenido(this.antecedentesNoPatologicos) ||
      tieneGineco
    );
  }

  get tieneSOAP(): boolean {
    return this.tipoNota === 'consulta';
  }

  get tieneSOAPConDatos(): boolean {
    if (!this.tieneSOAP) return false;
    return (
      this.tieneTextoConContenido(this.nota?.motivo_consulta) ||
      this.tieneTextoConContenido(this.nota?.soap_subjetivo) ||
      this.tieneTextoConContenido(this.nota?.soap_objetivo) ||
      this.tieneTextoConContenido(this.nota?.soap_analisis) ||
      this.tieneTextoConContenido(this.nota?.soap_plan)
    );
  }

  get tieneAntecedentesHeredofamiliares(): boolean {
    return this.tieneValorConContenido(this.antecedentesHeredofamiliares);
  }

  get tieneAntecedentesPatologicos(): boolean {
    return this.tieneValorConContenido(this.antecedentesPatologicos);
  }

  get tieneAntecedentesNoPatologicos(): boolean {
    return this.tieneValorConContenido(this.antecedentesNoPatologicos);
  }

  get tieneAntecedentesGinecoObstetricos(): boolean {
    return !this.esPacienteMasculino && this.tieneValorConContenido(this.antecedentesGinecoObstetricos);
  }

  get tieneDetalleEstructuradoHeredofamiliares(): boolean {
    const h = this.antecedentesHeredofamiliares;
    return (
      this.tieneValorConContenido(h?.paternos?.padre) ||
      this.tieneValorConContenido(h?.paternos?.abuelo) ||
      this.tieneValorConContenido(h?.paternos?.abuela) ||
      this.tieneValorConContenido(h?.paternos?.otros) ||
      this.tieneValorConContenido(h?.maternos?.madre) ||
      this.tieneValorConContenido(h?.maternos?.abuelo) ||
      this.tieneValorConContenido(h?.maternos?.abuela) ||
      this.tieneValorConContenido(h?.maternos?.otros) ||
      this.tieneValorConContenido(h?.hermanos) ||
      this.tieneValorConContenido(h?.hijos) ||
      this.tieneValorConContenido(h?.otros)
    );
  }

  get tieneDetalleEstructuradoPatologicos(): boolean {
    const p = this.antecedentesPatologicos;
    return (
      this.tieneValorConContenido(p?.cronicos_degenerativos) ||
      this.tieneValorConContenido(p?.alergicos) ||
      this.tieneValorConContenido(p?.quirurgicos) ||
      (p?.transfusiones_si && this.tieneValorConContenido(p?.transfusiones)) ||
      p?.tatuajes_si ||
      p?.tabaquismo_si ||
      p?.alcoholismo_si ||
      p?.toxicomanias_si
    );
  }

  get tieneDetalleEstructuradoNoPatologicos(): boolean {
    const np = this.antecedentesNoPatologicos;
    return (
      this.tieneValorConContenido(np?.hemotipo) ||
      this.tieneValorConContenido(np?.actividad_fisica) ||
      this.tieneValorConContenido(np?.vivienda)
    );
  }

  get tieneDetalleEstructuradoGinecoObstetricos(): boolean {
    const g = this.antecedentesGinecoObstetricos;
    return (
      this.tieneValorConContenido(g?.gesta) ||
      this.tieneValorConContenido(g?.partos) ||
      this.tieneValorConContenido(g?.cesareas) ||
      this.tieneValorConContenido(g?.abortos)
    );
  }

  get tieneEvolucionPadecimiento(): boolean {
    return ['ingreso', 'evolucion', 'egreso'].includes(this.tipoNota);
  }

  get tienePlanUrgencias(): boolean {
    return this.tipoNota === 'urgencias';
  }

  get planUrgenciasData(): any {
    return this.parsePlanUrgencias(this.nota?.soap_plan, this.tipoNota);
  }

  get tipoUrgenciaLabel(): string {
    return this.calcularTipoUrgenciaLabel(this.planUrgenciasData);
  }

  get contenidoPlanProcesado(): string {
    return this.extraerContenidoPlan(this.nota?.soap_plan);
  }

  get nombreIndicaciones(): string {
    const mapeo: Record<string, string> = {
      consulta: 'Indicaciones Médicas',
      urgencias: 'Indicaciones Médicas',
      ingreso: 'Indicaciones Hospitalarias',
      evolucion: 'Indicaciones Hospitalarias',
      egreso: 'Indicaciones Médicas',
    };
    return mapeo[this.tipoNota] || 'Indicaciones';
  }

  get antecedentesHeredofamiliares(): any {
    return this.nota?.antecedentes?.heredofamiliares || null;
  }

  get antecedentesPatologicos(): any {
    return this.nota?.antecedentes?.patologicos || null;
  }

  get antecedentesNoPatologicos(): any {
    return this.nota?.antecedentes?.no_patologicos || null;
  }

  get antecedentesGinecoObstetricos(): any {
    return this.nota?.antecedentes?.gineco_obstetricos || null;
  }

  get esPacienteMasculino(): boolean {
    const gender = this.nota?.patient?.gender || '';
    return gender.toUpperCase() === 'H';
  }

  get diagnosticos(): any[] {
    const items = this.nota?.diagnoses_cie11 || [];
    return items.filter((d: any) =>
      this.tieneTextoConContenido(d?.cie10) ||
      this.tieneTextoConContenido(d?.codigo) ||
      this.tieneTextoConContenido(d?.code) ||
      this.tieneTextoConContenido(d?.descripcion) ||
      this.tieneTextoConContenido(d?.description)
    );
  }

  get signosVitales(): any {
    return this.nota?.vital_signs || this.nota?.signos_vitales || null;
  }

  get resumenGeneral(): string | null {
    return this.nota?.resumen || null;
  }

  get recomendaciones(): string | null {
    return this.nota?.recommendations || null;
  }

  get diagnosticoTexto(): string | null {
    return this.nota?.diagnosis || null;
  }

  get paraclinicos(): any[] {
    const items = this.nota?.paraclinicos || this.nota?.lab_results || [];
    return this.filtrarItemsDeEstaNota(items).filter(item => this.tieneTextoConContenido(this.formatearItem(item)));
  }

  get escalasClinicas(): any[] {
    const items = this.nota?.escalas_clinicas || [];
    return items.filter((e: any) =>
      this.tieneTextoConContenido(e?.scaleKey) ||
      this.tieneTextoConContenido(e?.nombre) ||
      this.tieneTextoConContenido(String(e?.resultScore ?? '')) ||
      this.tieneTextoConContenido(String(e?.resultado ?? '')) ||
      this.tieneTextoConContenido(e?.resultClass)
    );
  }

  get solicitudes(): any[] {
    const items = this.nota?.solicitudes || [];
    return this.filtrarItemsDeEstaNota(items).filter(item => this.tieneTextoConContenido(this.formatearItem(item)));
  }

  get interconsultas(): any[] {
    const items = this.nota?.interconsultas || [];
    return this.filtrarItemsDeEstaNota(items).filter(item => this.tieneTextoConContenido(this.formatearItem(item)));
  }

  get indicaciones(): any[] {
    const mapeoIndicaciones: Record<string, string> = {
      consulta: 'indicaciones_medicas',
      urgencias: 'indicaciones_medicas',
      ingreso: 'indicaciones_hospitalarias',
      evolucion: 'indicaciones_hospitalarias',
      egreso: 'indicaciones_medicas',
    };
    const campo = mapeoIndicaciones[this.tipoNota];
    const items = this.nota?.[campo] || this.nota?.medicamentos || this.nota?.prescriptions || [];
    return this.filtrarItemsDeEstaNota(items).filter(item => this.tieneTextoConContenido(this.formatearItem(item)));
  }

  private filtrarItemsDeEstaNota(items: any[]): any[] {
    if (!items || items.length === 0) return [];

    const notaCreatedAt = this.nota?.created_at;
    if (!notaCreatedAt) return items;

    const notaDate = new Date(notaCreatedAt).getTime();
    const toleranciaMs = 60 * 60 * 1000;

    return items.filter(item => {
      const itemDate = item.fecha_solicitud || item.created_at || item.fecha_creacion || item.fecha;
      if (!itemDate) return true;

      const itemTimestamp = new Date(itemDate).getTime();
      return itemTimestamp >= (notaDate - toleranciaMs);
    });
  }

  formatearAntecedentes(antecedentes: any, nivel: number = 0): string {
    if (!antecedentes) return 'No registrado';

    if (typeof antecedentes === 'string') {
      return antecedentes || 'No registrado';
    }

    if (Array.isArray(antecedentes)) {
      return antecedentes.length > 0 ? antecedentes.join(', ') : 'No registrado';
    }

    if (typeof antecedentes === 'object') {
      const valores = Object.entries(antecedentes)
        .filter(([key, value]) => {
          if (value === null || value === undefined || value === '') return false;
          if (typeof value === 'object' && Object.keys(value).length === 0) return false;
          return true;
        })
        .map(([key, value]) => {
          const keyFormatted = key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

          if (typeof value === 'object' && !Array.isArray(value)) {
            const valorFormateado = this.formatearAntecedentes(value, nivel + 1);
            if (valorFormateado === 'No registrado') return null;
            return nivel === 0
              ? `\n${keyFormatted}:\n  ${valorFormateado.split('\n').join('\n  ')}`
              : `${keyFormatted}: ${valorFormateado}`;
          }

          if (Array.isArray(value)) {
            return `${keyFormatted}: ${value.join(', ')}`;
          }

          return `${keyFormatted}: ${value}`;
        })
        .filter(v => v !== null);

      return valores.length > 0 ? valores.join(nivel === 0 ? '' : ', ') : 'No registrado';
    }

    return 'No registrado';
  }

  formatearSignosVitales(signos: any): string[] {
    if (!signos) return [];
    const resultado: string[] = [];

    if ((signos.ta_sistolica && signos.ta_diastolica) || (signos.blood_pressure_systolic && signos.blood_pressure_diastolic)) {
      const sistolica = signos.blood_pressure_systolic || signos.ta_sistolica;
      const diastolica = signos.blood_pressure_diastolic || signos.ta_diastolica;
      resultado.push(`TA: ${sistolica}/${diastolica} mmHg`);
    } else if (signos.blood_pressure) {
      resultado.push(`TA: ${signos.blood_pressure}`);
    }

    const fc = signos.heart_rate || signos.fc;
    if (fc) resultado.push(`FC: ${fc} lpm`);

    const fr = signos.respiratory_rate || signos.fr;
    if (fr) resultado.push(`FR: ${fr} rpm`);

    const temp = signos.temperature || signos.temp;
    if (temp) resultado.push(`Temperatura: ${temp} °C`);

    if (signos.spo2) resultado.push(`SpO₂: ${signos.spo2}%`);

    const peso = signos.weight || signos.peso;
    if (peso) resultado.push(`Peso: ${peso} kg`);

    const talla = signos.height || signos.talla_cm;
    if (talla) resultado.push(`Talla: ${talla} cm`);

    const imc = signos.imc;
    if (imc) resultado.push(`IMC: ${imc}`);

    return resultado;
  }

  /**
   * Limpia el HTML y devuelve solo texto plano
   */
  stripHtml(html: string): string {
    if (!html) return '';
    if (typeof html !== 'string') return String(html);
    // Crear un elemento temporal para extraer el texto
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  tieneTextoConContenido(valor: any): boolean {
    if (valor === null || valor === undefined) return false;
    const texto = this.stripHtml(String(valor))
      .replace(/&nbsp;/g, ' ')
      .trim();
    return texto.length > 0;
  }

  private tieneValorConContenido(valor: any): boolean {
    if (valor === null || valor === undefined) return false;

    if (typeof valor === 'string') {
      return this.tieneTextoConContenido(valor);
    }

    if (typeof valor === 'number') {
      return !Number.isNaN(valor);
    }

    if (typeof valor === 'boolean') {
      return valor;
    }

    if (Array.isArray(valor)) {
      return valor.some(v => this.tieneValorConContenido(v));
    }

    if (typeof valor === 'object') {
      return Object.values(valor).some(v => this.tieneValorConContenido(v));
    }

    return false;
  }

  /**
   * Formatea un item de indicación/solicitud/interconsulta para mostrar
   */
  formatearItem(item: any): string {
    if (!item) return '';

    if (typeof item === 'string') {
      return this.stripHtml(item);
    }

    if (typeof item === 'object') {
      // Para hemoderivados
      if (item.tipo === 'hemoderivados' && item.hemoderivados && Array.isArray(item.hemoderivados)) {
        const hemos = item.hemoderivados
          .map((h: any) => {
            const tipo = this.getLabelTipoHemoderivado(h.tipo_hemoderivado);
            const via = h.via_administracion ? ` vía ${h.via_administracion}` : '';
            const velocidad = h.velocidad ? ` a ${h.velocidad} ml/h` : '';
            return `${tipo}${via}${velocidad}`;
          })
          .filter((n: string) => n);
        const nombre = item.nombre || 'Hemoderivados';
        return hemos.length > 0 ? `${nombre}: ${hemos.join(', ')}` : nombre;
      }

      // Para indicaciones médicas/recetas con modo texto enriquecido
      if (item.tipo === 'receta' && item.modo_entrada === 'texto' && item.contenido_html) {
        const nombre = item.nombre || 'Receta';
        const textoLimpio = this.stripHtml(item.contenido_html);
        return textoLimpio ? `${nombre}: ${textoLimpio}` : nombre;
      }

      // Para indicaciones médicas/recetas con array de medicamentos
      if (item.tipo === 'receta' && item.medicamentos && Array.isArray(item.medicamentos)) {
        const meds = item.medicamentos.map((m: any) => m.nombre || m.medicamento || '').filter((n: string) => n);
        const nombre = item.nombre || 'Receta';
        return meds.length > 0 ? `${nombre}: ${meds.join(', ')}` : nombre;
      }

      // Para indicaciones médicas/recetas individuales
      if (item.medicamento || item.medication) {
        const med = item.medicamento || item.medication || '';
        const dosis = item.dosis || item.dosage || '';
        const frecuencia = item.frecuencia || item.frequency || '';
        const duracion = item.duracion || item.duration || '';
        let texto = med;
        if (dosis) texto += ` - ${dosis}`;
        if (frecuencia) texto += ` - ${frecuencia}`;
        if (duracion) texto += ` por ${duracion}`;
        return texto;
      }

      // Para solicitudes con tipo (laboratorio, gabinete, etc.)
      if (item.tipo_solicitud || item.tipo) {
        const tipo = item.tipo_solicitud || item.tipo || '';
        const desc = item.contenido || item.descripcion || item.description || item.nombre || '';
        const textoDesc = this.stripHtml(desc);
        if (tipo && textoDesc) {
          return `${tipo.charAt(0).toUpperCase() + tipo.slice(1)}: ${textoDesc}`;
        }
        return textoDesc || tipo || '';
      }

      // Para interconsultas
      if (item.especialidad || item.specialty || item.categoria) {
        const esp = item.especialidad || item.specialty || item.categoria || '';
        const motivo = item.motivo || item.reason || item.contenido || item.titulo || item.descripcion || '';
        return esp ? `${esp}: ${this.stripHtml(motivo)}` : this.stripHtml(motivo);
      }

      // Propiedades genéricas
      const descripcion = item.contenido || item.descripcion || item.description || item.texto || item.text || item.content || item.nombre || item.name || item.titulo || item.title;
      if (descripcion) {
        return this.stripHtml(descripcion);
      }

      // Último recurso: serializar las propiedades relevantes
      const props = Object.entries(item)
        .filter(([k, v]) => v && typeof v !== 'object' && !['id', 'created_at', 'updated_at', 'fecha_creacion', 'ultima_modificacion', 'fecha_solicitud', 'finalizada', 'origen'].includes(k))
        .map(([k, v]) => `${k}: ${v}`)
        .join(', ');

      return props || 'Sin descripción';
    }

    return String(item);
  }

  /**
   * Genera un grid de signos vitales con iconos para visualizacion
   */
  get signosVitalesGrid(): SignoVitalItem[] {
    const signos = this.signosVitales;
    if (!signos) return [];

    const grid: SignoVitalItem[] = [];

    const sistolica = signos.blood_pressure_systolic || signos.ta_sistolica;
    const diastolica = signos.blood_pressure_diastolic || signos.ta_diastolica;
    if (sistolica || diastolica) {
      grid.push({
        nombre: 'Presion Arterial',
        valor: `${sistolica || '-'}/${diastolica || '-'}`,
        unidad: 'mmHg',
        icono: this.ICONOS['TA'],
        viewBox: this.VIEWBOXES['TA']
      });
    }

    const fc = signos.heart_rate || signos.fc;
    if (fc) {
      grid.push({
        nombre: 'Frec. Cardiaca',
        valor: fc,
        unidad: 'lpm',
        icono: this.ICONOS['FC'],
        viewBox: this.VIEWBOXES['FC']
      });
    }

    const fr = signos.respiratory_rate || signos.fr;
    if (fr) {
      grid.push({
        nombre: 'Frec. Respiratoria',
        valor: fr,
        unidad: 'rpm',
        icono: this.ICONOS['FR'],
        viewBox: this.VIEWBOXES['FR']
      });
    }

    const temp = signos.temperature || signos.temp;
    if (temp) {
      grid.push({
        nombre: 'Temperatura',
        valor: temp,
        unidad: 'C',
        icono: this.ICONOS['TEMP'],
        viewBox: this.VIEWBOXES['TEMP']
      });
    }

    if (signos.spo2) {
      grid.push({
        nombre: 'SpO2',
        valor: signos.spo2,
        unidad: '%',
        icono: this.ICONOS['SPO2'],
        viewBox: this.VIEWBOXES['SPO2']
      });
    }

    const peso = signos.weight || signos.peso;
    if (peso) {
      grid.push({
        nombre: 'Peso',
        valor: peso,
        unidad: 'kg',
        icono: this.ICONOS['PESO'],
        viewBox: this.VIEWBOXES['PESO']
      });
    }

    const talla = signos.height || signos.talla_cm;
    if (talla) {
      grid.push({
        nombre: 'Talla',
        valor: talla,
        unidad: 'cm',
        icono: this.ICONOS['TALLA'],
        viewBox: this.VIEWBOXES['TALLA']
      });
    }

    if (signos.imc) {
      grid.push({
        nombre: 'IMC',
        valor: signos.imc,
        unidad: 'kg/m2',
        icono: this.ICONOS['IMC'],
        viewBox: this.VIEWBOXES['IMC']
      });
    }

    return grid;
  }

  /**
   * Verifica si el icono es un array de paths
   */
  isIconArray(icono: string | string[]): boolean {
    return Array.isArray(icono);
  }

  /**
   * Convierte icono a array para iteracion en template
   */
  getIconPaths(icono: string | string[]): string[] {
    return Array.isArray(icono) ? icono : [icono];
  }

  /**
   * Devuelve el color apropiado para el puntaje AUDIT
   */
  getAuditColor(score: number): string {
    if (score <= 7) return '#22c55e'; // green - bajo riesgo
    if (score <= 15) return '#f59e0b'; // amber - riesgo moderado
    if (score <= 19) return '#f97316'; // orange - alto riesgo
    return '#ef4444'; // red - dependencia
  }

  /**
   * Formatea la clave de un objeto para mostrar
   */
  formatKey(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }

  /**
   * Obtiene el array de keys de un objeto para iterar en template
   */
  getObjectKeys(obj: any): string[] {
    if (!obj || typeof obj !== 'object') return [];
    return Object.keys(obj).filter(k =>
      obj[k] !== null &&
      obj[k] !== undefined &&
      obj[k] !== '' &&
      !k.startsWith('audit_') // Excluir campos AUDIT que se manejan aparte
    );
  }

  /**
   * Verifica si un valor es un objeto
   */
  isObject(value: any): boolean {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  /**
   * Verifica si un valor es un array
   */
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  /**
   * Verifica si un valor es primitivo (string, number, boolean)
   */
  isPrimitive(value: any): boolean {
    return value !== null && typeof value !== 'object';
  }

  private readonly listaDrogas = [
    { value: 'alcohol', label: 'Alcohol' },
    { value: 'tabaco', label: 'Tabaco' },
    { value: 'marihuana', label: 'Marihuana' },
    { value: 'cocaina', label: 'Cocaína' },
    { value: 'heroina', label: 'Heroína' },
    { value: 'metanfetaminas', label: 'Metanfetaminas' },
    { value: 'lsd', label: 'LSD' },
    { value: 'extasis', label: 'Éxtasis' },
    { value: 'inhalantes', label: 'Inhalantes' },
    { value: 'benzodiacepinas', label: 'Benzodiacepinas' },
    { value: 'opioides', label: 'Opioides' },
    { value: 'otros', label: 'Otros' }
  ];

  getNombreDroga(value: string): string {
    const droga = this.listaDrogas.find(d => d.value === value);
    return droga ? droga.label : value;
  }

  private readonly tiposHemoderivado = [
    { value: 'paquete_globular', label: 'Paquete Globular' },
    { value: 'paquete_plaquetario', label: 'Paquete Plaquetario' },
    { value: 'crioprecipitado', label: 'Crioprecipitado' },
    { value: 'plasma_fresco_congelado', label: 'Plasma Fresco Congelado' },
  ];

  getLabelTipoHemoderivado(value: string | null): string {
    if (!value) return 'No especificado';
    const tipo = this.tiposHemoderivado.find(t => t.value === value);
    return tipo ? tipo.label : value;
  }

  formatScaleName(scaleKey: string): string {
    if (!scaleKey) return 'Escala';

    const nombres: Record<string, string> = {
      glasgow: 'Glasgow',
      child_pugh: 'Child Pugh',
      meld: 'MELD',
      apache_ii: 'APACHE II',
      qsofa: 'qSOFA',
      sofa: 'SOFA',
      asa: 'ASA',
      nyha: 'NYHA',
      audit: 'AUDIT'
    };

    const keyNormalizada = String(scaleKey).toLowerCase();
    if (nombres[keyNormalizada]) return nombres[keyNormalizada];

    return String(scaleKey)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }

  getScaleResultClass(escala: any): string {
    return (
      escala?.resultClass ||
      escala?.classification ||
      escala?.clasificacion ||
      ''
    );
  }

  getScaleSeverityColor(escala: any): 'green' | 'amber' | 'red' | 'blue' {
    const clase = String(this.getScaleResultClass(escala)).toLowerCase();
    const score = Number(escala?.numericScore ?? escala?.resultScore ?? escala?.resultado);

    if (clase.includes('sever') || clase.includes('alto') || clase.includes('high') || clase.includes('grave')) return 'red';
    if (clase.includes('moder') || clase.includes('intermed') || clase.includes('medio') || clase.includes('amber')) return 'amber';
    if (clase.includes('bajo') || clase.includes('low') || clase.includes('normal') || clase.includes('leve')) return 'green';

    if (Number.isFinite(score)) {
      if (score >= 15) return 'red';
      if (score >= 8) return 'amber';
      if (score >= 1) return 'green';
    }

    return 'blue';
  }

  getParaclinicoColor(tipo?: string | null): 'blue' | 'purple' | 'teal' | 'gray' {
    const t = String(tipo || '').toLowerCase();
    if (!t) return 'gray';

    if (
      t.includes('laboratorio') ||
      t.includes('lab') ||
      t.includes('quimica') ||
      t.includes('biometria') ||
      t.includes('hematolog') ||
      t.includes('cultivo')
    ) return 'blue';

    if (
      t.includes('gabinete') ||
      t.includes('imagen') ||
      t.includes('rx') ||
      t.includes('radi') ||
      t.includes('tac') ||
      t.includes('tomografia') ||
      t.includes('resonancia') ||
      t.includes('ultrason') ||
      t.includes('endoscop')
    ) return 'purple';

    if (
      t.includes('patologia') ||
      t.includes('histopat') ||
      t.includes('citologia') ||
      t.includes('biopsia')
    ) return 'teal';

    return 'gray';
  }

  formatTipoParaclinico(tipo?: string | null): string {
    const t = String(tipo || '').toLowerCase();
    if (!t) return 'General';

    const nombres: Record<string, string> = {
      laboratorio: 'Laboratorio',
      gabinete: 'Gabinete',
      imagen: 'Imagen',
      radiologia: 'Radiologia',
      ultrasonido: 'Ultrasonido',
      tomografia: 'Tomografia',
      resonancia: 'Resonancia',
      endoscopia: 'Endoscopia',
      patologia: 'Patologia'
    };

    if (nombres[t]) return nombres[t];

    return t
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }

  private parsePlanUrgencias(plan: any, tipoNota: string): any {
    if (tipoNota !== 'urgencias' || !plan) return null;
    if (typeof plan === 'object' && plan !== null) return plan;
    try {
      return JSON.parse(plan);
    } catch {
      return null;
    }
  }

  private extraerContenidoPlan(plan: any): string {
    if (!plan) return '';
    if (typeof plan === 'object' && plan !== null) {
      return plan.contenido || '';
    }
    return plan;
  }

  private calcularTipoUrgenciaLabel(data: any): string {
    if (!data?.tipo_urgencia) return '';
    const labels: { [key: string]: string } = {
      ambulatoria: 'Alta Ambulatoria',
      hospitalizacion: 'Hospitalizacion',
    };
    return labels[data.tipo_urgencia] || data.tipo_urgencia;
  }

  solicitarVerResumenCompleto(): void {
    this.verResumenCompleto.emit();
  }
}
